import React from 'react';
import PropTypes from 'prop-types';
import {
  ListGroupItem,
  Label,
  Input,
} from 'reactstrap';

const AdminGroupEditCapabilitiesItem = ({
  capability,
  capabilityName,
  checked,
  handleCapabilitySwitch,
}) => (
  <ListGroupItem>
    <Label for={`switchGroup-${capability}`} className="switch">
      <div className="switch-details">
        <span>
          {capabilityName}
        </span>
      </div>
      <div className="switch-control input-inner">
        <Input
          type="checkbox"
          name="groupUploadFile"
          id={`switchGroup-${capability}`}
          value="true"
          checked={checked}
          onChange={() => { handleCapabilitySwitch(capability); }}
        />
        <i />
      </div>
    </Label>
  </ListGroupItem>
);

AdminGroupEditCapabilitiesItem.propTypes = {
  capability: PropTypes.string.isRequired,
  capabilityName: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleCapabilitySwitch: PropTypes.func.isRequired,
};

export default AdminGroupEditCapabilitiesItem;
